import * as session from './api/session';
import * as telematics from './api/telematics';
import * as organizational_units from './api/organizational_units';
import * as portal from './api/portal';
import * as geo from './api/geo';
import * as vehicles from './api/vehicles';
import * as routing from './api/routing';
import * as storage from './api/storage';
import * as mobile from './api/mobile';
import * as dictionary from './api/dictionary';
import * as garbage from './api/garbage';
import * as reports from './api/reports';
import * as kurs from './api/kurs';
import * as auth from './api/auth';

export const api = {
    auth: {
        getGuestToken: auth.getGuestToken,
    },
    dictionary: {
        getDictionaryList: dictionary.getDictionaryList,
        getDictionaryLists: dictionary.getDictionaryLists,
    },
    wsrpc: {
        connectionLost: session.connectionLost,
        connectionEstablished: session.connectionEstablished
    },
    reports: {
        getTabletWorkSummary: reports.getTabletWorkSummary
    },
    kurs: {
        getTasks: kurs.getTasks,
        getTasksGuests: kurs.getTasksGuests,
        getGeometryFromContract: kurs.getGeometryFromContract,
    },
    telematics: {
        getTelematicsWithDevices: telematics.getTelematicsWithDevices,
        getTelematics: telematics.getTelematics,
        getTelematicsTotalCount: telematics.getTelematicsTotalCount,
        telematicsUpdateSubscribe: telematics.telematicsUpdateSubscribe,
        telematicsUpdateUnsubscribe: telematics.telematicsUpdateUnsubscribe,
        filtersUpdate: telematics.filtersUpdate,
    },
    organizational_units: {
        getCarriers: organizational_units.getCarriers,
        getUnit: organizational_units.getUnit,
    },
    geo: {
        routing: geo.routing,
        getClosestStopPoint: geo.getClosestStopPoint,
        geocode: geo.geocode,
        searchAddress: geo.searchAddress,
        reverseGeocode: geo.reverseGeocode,
        listLayers: geo.listLayers,
        listUserGeoObjectsByLayers: geo.listUserGeoObjectsByLayers,
        getStopPoints: geo.getStopPoints,
        getStopPointRoutes: geo.getStopPointRoutes,
        getStopPointRouteRuns: geo.getStopPointRouteRuns,
        listUserGeoObjectsMO: geo.listUserGeoObjectsMO,
        portalSchedule: geo.portalSchedule,
        portalScheduleExtended: geo.portalScheduleExtended,
        portalScheduleRoute: geo.portalScheduleRoute,
    },
    vehicles: {
        getVehicleList: vehicles.getVehicleList,
        getVehicleListGuest: vehicles.getVehicleListGuest,
    },
    portal: {
        getNews: portal.getNews,
        getNewsItem: portal.getNewsItem,
        getFaq: portal.getFaq,
        getPage: portal.getPage,
        sendFeedback: portal.sendFeedback,
        getCaptcha: portal.getCaptcha,
        checkRegisterRequestCreate: portal.checkRegisterRequestCreate,
        createRegisterRequest: portal.createRegisterRequest,
        getRegisterRequest: portal.getRegisterRequest,
        updateRegisterRequest: portal.updateRegisterRequest,
        loginRegisterRequest: portal.loginRegisterRequest,
        getTags: portal.getTags,
    },
    routing: {
        find: routing.find,
    },
    storage: {
        getUploadToken: storage.getUploadToken,
        uploadFile: storage.uploadFile,
    },
    mobile: {
        confirmEmailCheck: mobile.confirmEmailCheck,
        confirmEmailChangeCheck: mobile.confirmEmailChangeCheck,
    },
    garbage: {
        getObjects: garbage.getObjects,
    },
};

export class CycleFetch {
    constructor(fetchResult, cb, delay = 1000) {
        this._fetch = fetchResult;
        this._onFetched = cb;
        this._delay = delay;
        this._runned = true;
        this._timeout = null;
    }

    run() {
        this._fetchOne();
    }

    forceNext() {
        if (this._timeout)
            this._timeout = clearTimeout(this._timeout);

        this._fetchOne();
    }

    forceNextWithDelay(delay) {
        if (this._timeout)
            this._timeout = clearTimeout(this._timeout);

        this._next(delay);
    }

    _fetchOne() {
        if (!this._runned) return;

        const fetchResult = this._fetch();
        if (fetchResult === null) {
            this.forceNextWithDelay(200);
        } else {
            fetchResult.then((result) => {
                if (!this._runned)
                    return;

                this._onFetched(result);
                this._next();
            })
                .catch(() => {
                    if (this._runned)
                        this._next();
                });
        }
    }

    _next(delay = null) {
        if (this._timeout)
            this._timeout = clearTimeout(this._timeout);

        this._timeout = setTimeout(::this._fetchOne, delay || this._delay)
    }

    stop() {
        this._runned = false;
        if (this._timeout)
            this._timeout = clearTimeout(this._timeout);
    }

}




// WEBPACK FOOTER //
// ./src/helpers/api.js